// @flow
import React, {useState} from 'react';
import {useHistory} from "react-router-dom";
import Header from "../Header";
import BackButton from "../../GUI_COMMON/COMPONENTS/BackButton";
import LIButton from "../../GUI_COMMON/COMPONENTS/LIButton";
import Popup from "../../GUI_COMMON/COMPONENTS/Popup";
import ArchiverClientApi from "../../API/archiverClientApi";
import LocationSelector from "../LocationSelector";
import ErrorPopup from "../../GUI_COMMON/COMPONENTS/ErrorPopup";

const BoxCreateAdminPage = () => {

    const [curLocationDetails] = useState(getDefaultLocation());
    const [destLocationDetails, setDestLocationDetails] = useState(getDefaultLocation());
    const [isBusy, setIsBusy] = useState(false);
    const [createMissingBoxesLabel, setCreateMissingBoxesLabel] = useState("Create Missing Boxes");
    
    const history = useHistory();
    
    // useEffect(() => {
    //     console.debug("refreshing locations list");
    //     getLocationsList();
    // }, []);
    //
    // function getLocationsList() {
    //     setIsLoading(true);
    //     ArchiverClientApi.getLocations(true) // request all enabled locations
    //     .then( (locations) => {
    //         setFullLocationsList(locations??[]);
    //     })
    //     .catch( responseError => ArchiverGuiUtils.ShowErrorIfNotUnauthourized(responseError))
    //     .finally( () => {
    //         setIsLoading(false);
    //     });
    // }
    
    function getDefaultLocation() {
        return {
            locationId:-1,
            deptId:-1
        }
    }

    function onChange(e) {
        const thing = e.target.name;
        let value = e.target.value;

        const locationEditInfo = {...destLocationDetails};
        if(thing==="toLocation-destLocation") { // value here is the id selected
            const locId = Number(value);
            if(isNaN(locId)) {
                locationEditInfo.locationId=-1;
                locationEditInfo.deptId=-1;   // reset
            }
            else {
                locationEditInfo.locationId=locId;
                locationEditInfo.deptId=-1;
            }
        }
        else if(thing==="toLocation-destDepartment") { // value here is the id selected
            locationEditInfo.deptId=Number(value);
        }
        
        setDestLocationDetails(locationEditInfo);
    }

    function checkForValid() {
        if(destLocationDetails.locationId===-1 || destLocationDetails.deptId===-1) {
            return false;
        }
        if(destLocationDetails.locationId===curLocationDetails.locationId && destLocationDetails.deptId===curLocationDetails.deptId) {
            return false;
        }
        return true;
    }
    
    function handleBackClicked() {
        history.goBack();
    }

    function handleCreateMissingBoxesClicked() {

        Popup.showConfirm("Create Missing Boxes?",
            "<p>Are you sure you want to create missing boxes?</p><p>This may take a few minutes and cannot be undone.</p>", "Yes, create them!",
            null, () => {
                doCreateMissingBoxes();
            });
    }
    function doCreateMissingBoxes() {

        setIsBusy(true);
        const destDepartmentId = destLocationDetails.deptId;
        ArchiverClientApi.requestCreateMissingBoxes(
            (progressValue:number, isDone:boolean=false, isError:boolean=false, finalResults:Object=null)=> {
            let updatedLabel = "Create Missing Boxes";
            if(!isDone && !isError) {
                console.debug("create missing boxes progress: "+progressValue);
                updatedLabel = `Creating ... ${progressValue}%`;
            }
            setCreateMissingBoxesLabel(updatedLabel);

            if(isDone===true) {
                setIsBusy(false);
                Popup.show("Box Creation Completed",`<b>Mags Processed:</b> ${finalResults.numProcessed}<br/><b>Boxes Created:</b> ${finalResults.numCreated}`);
            }
            if(isError===true) {
                setIsBusy(false);
                ErrorPopup.showError("Create Missing Boxes Error",`<p>Failed to create missing boxes.</p><p>Reason: ***<b>${finalResults.errorReason}</b>***</p>`);
            }
        }, destDepartmentId); // we pass in the desired dept id for new boxes here
    }
    
    return (
        <div className="container">
            <Header hideAdmin/>
            <div className="li-header-row">
                <BackButton onClick={handleBackClicked}/>
                <h1 className="ml-4 d-inline-block align-middle">Box Create</h1>
            </div>
            <p>In older systems, boxes did not exist as standalone entities  This service level function forces the system
                to go through <strong>ALL</strong> the mags in the system and creates boxes for each set of mags that may not have a 
                matching box.</p>
            <p>Box, magazine, and sample histories will be updated and the locations of the boxes will be set to the destination location that you select here.</p>
            <p>Note that</p>
            <ul>
                <li>Any boxes that already exist in the system that have locations will not be changed.</li>
                <li>Any boxes that do not exist in the system will be created and moved to the location you select.</li>
                <li>Any child magazines will be moved to the same location as their parent box (if their parent box does not currently
                    have a location assigned)</li>
                <li>Any samples that are contained in the magazines that are moved will be marked as being off-premises if their parent mag is off-premises.</li>
            </ul>

            <hr/>
                
                <div className="row">
                    <div className="offset-3 col-6 mt-3">
                        <h4 className="text-center">Box Destination Location</h4>
                        <div className="li-border-round li-border-dark p-2">
                            <div className="row px-3 pb-3 li-bg-light">
                                <div className="col-12">
                                    <LocationSelector name="toLocation" onChange={onChange} locationLabel="Location"
                                                      locationValue={destLocationDetails.locationId}
                                                      departmentValue={destLocationDetails.deptId}
                                                      onIsValid={checkForValid}
                                                      showContact={false}
                                                      showOffPremises={true}
                                                      required={true}
                                                      withDepartmentsOnly/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
            <h4 className="mt-5 w-75 ml-auto mr-auto">Warning: If you move away from this page once the operation is started, 
                you won't know when it's finished. It can take a while to complete on large systems.</h4>

            <div className="text-center my-5">
                <LIButton name="cancel" label="Cancel" bgClass="mr-4" primary onClick={handleBackClicked} disabled={isBusy}/>
                <LIButton primary onClick={handleCreateMissingBoxesClicked} label={createMissingBoxesLabel}
                          disabled={isBusy || !checkForValid()}
                          fitHeight/>
            </div>
        </div>
    );
}

BoxCreateAdminPage.propTypes = {
};

export default BoxCreateAdminPage;